import * as Yup from 'yup'
import { VALIDATION_KEYS } from '../utils/translation-constants'
import validationConfig from "custom/config/validation.config.json";
const instantTransferConfig = validationConfig["quickPay"];
const internalBeneConfig = validationConfig["addBeneficiary"]["internal"];
const domesticBeneConfig = validationConfig["addBeneficiary"]["domestic"];
const internationalBeneConfig =
  validationConfig["addBeneficiary"]["international"];
const internalTransferConfig = validationConfig["transfers"]["internal"];
const domesticTransferConfig = validationConfig["transfers"]["domestic"];
const internationalTransferConfig =
  validationConfig["transfers"]["international"];
const ownTransferConfig = validationConfig["transfers"]["own"];
const bulkTransferConfig = validationConfig["bulkTransfer"];
const editInternalConfig = validationConfig["editBeneficiary"]["internal"];
const editDomesticConfig = validationConfig["editBeneficiary"]["domestic"];
const salaryUploadConfig=validationConfig["salaryUpload"]
const regionalBeneConfig = validationConfig["addBeneficiary"]["regional"];
const regionalTransferConfig = validationConfig["transfers"]["regional"];
import config from 'custom/config/environment'

const validateAccountType = instantTransferConfig["isTransferTypeRequired"]
  ? {
    accountType: Yup.string().required(VALIDATION_KEYS.ACCOUNT_TYPE_REQUIRED),
    }
  : {
      accountType: Yup.string().optional(),
    };

const validateTransactionCurrency = instantTransferConfig["isTransactionCurrencyRequired"]
  ? {
    txnCurrency: Yup.string().required(VALIDATION_KEYS.TRANSCTIONCURRENY),
  }
  : {
    txnCurrency: Yup.string().optional(),
  };

const validateBankName = instantTransferConfig["isBeneBankRequired"]
  ? {
    bankName: Yup.string().when('accountType', {
      // .when('transferType', {
      is: 'IAT',
      then: Yup.string(),
      otherwise: Yup.string().required(VALIDATION_KEYS.BANK_NAME_REQUIRED),
    }),
    }
  : {
      bankName: Yup.string().optional(),
    };

const validateBranchName = instantTransferConfig["isBranchRequired"]
  ? {
    branchName: Yup.string().when('accountType', {
      // .when('transferType', {
      is: 'IAT',
      then: Yup.string(),
      otherwise: Yup.string().required(VALIDATION_KEYS.BRANCH_NAME_REQUIRED),
    }),
    }
  : {
      branchName: Yup.string().optional(),
    };

const validateAccountNo = instantTransferConfig["isAccountNoRequired"]
  ? {
    accountNumber: Yup.string().when('accountType', {
      is: 'IAT',
      then: Yup.string()
        .min(config.ACC_NO_LENGTH, VALIDATION_KEYS.ACCOUNT_NO_DIGIT)
        .required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
      otherwise: Yup.string()
        .min(5, VALIDATION_KEYS.ACCOUNT_NO_MIN_MAX)
        .max(20, VALIDATION_KEYS.ACCOUNT_NO_MIN_MAX)
        .required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
    }),
    }
  : {
      accountNumber: Yup.string().optional(),
    };

const validateConfirmAccountNo = instantTransferConfig[
  "isConfirmAccountNoRequired"
]
  ? {
    confirmAccountNumber: Yup.string()
    .oneOf([Yup.ref('accountNumber'), null], VALIDATION_KEYS.CONFIRM_ACCOUNT_NO_MATCH)
    .required(VALIDATION_KEYS.CONFIRM_ACCOUNT_NO_REQUIRED),
  }
  : {
      confirmAccountNumber: Yup.string().optional(),
    };

const validateBeneName = instantTransferConfig["isBeneNameRequired"]
  ? {
    beneficiaryName: Yup.string().when('accountType', {
      // .when('transferType', {
      is: 'IAT',
      then: Yup.string(),
      otherwise: Yup.string()
        .required(VALIDATION_KEYS.BENEFICIARY_NAME_REQUIRED)
        .min(2, VALIDATION_KEYS.BENEFICIARY_MIN_MAX)
        .max(32, VALIDATION_KEYS.BENEFICIARY_MIN_MAX),
    }),
    }
  : {
    beneficiaryName:  Yup.string().optional(),
    };

const validateRemarks = instantTransferConfig["isRemarksRequired"]
  ? {
    remarks: Yup.string().min(4, 'Minimum 4 Characters').required(VALIDATION_KEYS.REMARKS_REQUIRED),
    }
  : {
      remarks: Yup.string().optional(),
    };

const validateCustomRemarks = instantTransferConfig["isCustomRemarksRequired"]
  ? {
    customRemarks: Yup.string().when('remarks', {
      is: 'Custom',
      then: Yup.string().required(VALIDATION_KEYS.CUSTOM_REMARK_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
    }
  : {
      customRemarks: Yup.string().optional(),
    };

const validateNickName = internalBeneConfig["isNickNameRequired"]
  ? {
    nickName: Yup.string()
    .required(VALIDATION_KEYS.NICK_NAME_REQUIRED)
    .matches(new RegExp('^[a-zA-Z_]*$'), VALIDATION_KEYS.VALID_NICK_NAME)
    .min(2, VALIDATION_KEYS.NICK_NAME_MIN_MAX)
    .max(20, VALIDATION_KEYS.NICK_NAME_MIN_MAX),
    }
  : {
      nickName: Yup.string().optional(),
    };
const validateInternalBeneAccountNo = internalBeneConfig["isAccountNoRequired"]
  ? {
    accountNumber: Yup.string()
    .min(config.ACC_NO_LENGTH, VALIDATION_KEYS.ACCOUNT_NO_DIGIT)
    .required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED)
    }
  : {
      accountNumber: Yup.string().optional(),
    };
const validateInternalBeneConfirmAccountNo = internalBeneConfig[
  "isConfirmAccountNoRequired"
]
  ? {
    confirmAccountNumber: Yup.string()
    .oneOf([Yup.ref('accountNumber'), null], VALIDATION_KEYS.ACCOUNT_NO_MATCH)
    .required(VALIDATION_KEYS.CONFIRM_ACCOUNT_NO_REQUIRED),
    }
  : {
      confirmAccountNumber: Yup.string().optional(),
    };
const validateInternalBeneTransaferAmount = internalBeneConfig[
  "isTransferLimitRequired"
]
  ? {
    maxTransferAmount: Yup.string().required(VALIDATION_KEYS.TRANSFER_LIMIT),
    }
  : {
      maxTransferAmount: Yup.string().optional(),
    };

const validateDomesticBeneNickName = domesticBeneConfig["isNickNameRequired"]
  ? {
    nickName: Yup.string()
    .required(VALIDATION_KEYS.NICK_NAME_REQUIRED)
    .matches(new RegExp('^[a-zA-Z_]*$'), VALIDATION_KEYS.VALID_NICK_NAME)
    .min(2, VALIDATION_KEYS.NICK_NAME_MIN_MAX)
    .max(20, VALIDATION_KEYS.NICK_NAME_MIN_MAX),
    }
  : {
      nickName: Yup.string().optional(),
    };
const validateDomesticBeneAccountNo = domesticBeneConfig["isAccountNoRequired"]
  ? {
    accountNumber: Yup.string()
    .min(23, VALIDATION_KEYS.ACCOUNT_NO_MIN_MAX)
    .max(23, VALIDATION_KEYS.ACCOUNT_NO_MIN_MAX)
    .required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
    }
  : {
      accountNumber: Yup.string().optional(),
    };
const validateDomesticBeneConfirmAccountNo = domesticBeneConfig[
  "isConfirmAccountNoRequired"
]
  ? {
    confirmAccountNumber: Yup.string()
    .oneOf([Yup.ref('accountNumber'), null], VALIDATION_KEYS.ACCOUNT_NO_MATCH)
    .required(VALIDATION_KEYS.CONFIRM_ACCOUNT_NO_REQUIRED),
    }
  : {
      confirmAccountNumber: Yup.string().optional(),
    };
const validateDomesticBeneTransaferAmount = domesticBeneConfig[
  "isTransferLimitRequired"
]
  ? {
      maxTransferAmount: Yup.string().required(VALIDATION_KEYS.TRANSFER_LIMIT),
    }
  : {
      maxTransferAmount: Yup.string().optional(),
    };

const validateDomesticBeneName = domesticBeneConfig["isBeneNameRequired"]
  ? {
    benName: Yup.string()
    .required(VALIDATION_KEYS.BENEFICIARY_NAME_REQUIRED)
    .matches(new RegExp('^[a-zA-Z ]*$'), VALIDATION_KEYS.BENEFICIARY_NAME_VALID)
    .min(2, VALIDATION_KEYS.BENEFICIARY_MIN_MAX)
    .max(32, VALIDATION_KEYS.BENEFICIARY_MIN_MAX),
    }
  : {
      benName: Yup.string().optional(),
    };

const validateDomesticBeneBankName = domesticBeneConfig["isBeneBankRequired"]
  ? {
    bankName: Yup.string().required(VALIDATION_KEYS.BENEFICIARY_BANK_REQUIRED),
    }
  : {
      bankName: Yup.string().optional(),
    };

const validateDomesticBeneBranchName = domesticBeneConfig["isBranchRequired"]
  ? {
    branchName: Yup.string().required(VALIDATION_KEYS.BRANCH_NAME_REQUIRED),
    }
  : {
      branchName: Yup.string().optional(),
    };

const validateDomesticBeneEmailID = domesticBeneConfig["isEmailRequired"]
  ? {
    beneEmail: Yup.string()
    .email(VALIDATION_KEYS.BENE_EMAIL_ID_VALIDATE)
    .required(VALIDATION_KEYS.BENE_EMAIL_ID_REQUIRED),
    }
  : {
      beneEmail: Yup.string().optional(),
    };

const validateDomesticBeneMobileNo = domesticBeneConfig["isMobileNoRequired"]
  ? {
    beneMobileNo: Yup.string()
    .min(8, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
    .max(15, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
    .required(VALIDATION_KEYS.BENE_MOBILE_NO_REQUIRED),
    }
  : {
      beneMobileNo: Yup.string().optional(),
    };

const validateInternationalBeneNickName = internationalBeneConfig[
  "isNickNameRequired"
]
  ? {
    nickName: Yup.string()
    .required(VALIDATION_KEYS.NICK_NAME_REQUIRED)
    .matches(new RegExp('^[a-zA-Z_]*$'), VALIDATION_KEYS.VALID_NICK_NAME)
    .min(7, VALIDATION_KEYS.NICK_NAME_MIN_MAX_LEN)
    .max(34, VALIDATION_KEYS.NICK_NAME_MIN_MAX_LEN),
    }
  : {
      nickName: Yup.string().optional(),
    };
const validateInternationalBeneAccountNo = internationalBeneConfig[
  "isAccountNoRequired"
]
  ? {
    accountNumber: Yup.string()
    .min(5, VALIDATION_KEYS.ACCOUNT_NO_MIN_MAX)
    .max(20, VALIDATION_KEYS.ACCOUNT_NO_MIN_MAX)
    .required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
    }
  : {
      accountNumber: Yup.string().optional(),
    };
const validateInternationalBeneConfirmAccountNo = internationalBeneConfig[
  "isConfirmAccountNoRequired"
]
  ? {
    confirmAccountNumber: Yup.string()
    .oneOf([Yup.ref('accountNumber'), null], VALIDATION_KEYS.ACCOUNT_NO_MATCH)
    .required(VALIDATION_KEYS.CONFIRM_ACCOUNT_NO_REQUIRED),
    }
  : {
      confirmAccountNumber: Yup.string().optional(),
    };
const validateInternationalBeneTransaferAmount = internationalBeneConfig[
  "isTransferLimitRequired"
]
  ? {
    maxTransferAmount: Yup.string().required(VALIDATION_KEYS.TRANSFER_LIMIT),
    }
  : {
      maxTransferAmount: Yup.string().optional(),
    };

const validateInternationalBeneName = internationalBeneConfig[
  "isBeneNameRequired"
]
  ? {
    benName: Yup.string()
    .matches(new RegExp('^[a-zA-Z ]*$'), VALIDATION_KEYS.BENEFICIARY_NAME_VALID)
    .required(VALIDATION_KEYS.BENEFICIARY_NAME_REQUIRED)
    .min(2, VALIDATION_KEYS.BENEFICIARY_MIN_MAX)
    .max(32, VALIDATION_KEYS.BENEFICIARY_MIN_MAX),
    }
  : {
      benName: Yup.string().optional(),
    };

const validateInternationalBeneBankName = internationalBeneConfig[
  "isBeneBankRequired"
]
  ? {
    bankName: Yup.string().required(VALIDATION_KEYS.BENEFICIARY_BANK_REQUIRED),
    }
  : {
      bankName: Yup.string().optional(),
    };

const validateInternationalBeneBranchName = internationalBeneConfig[
  "isBranchRequired"
]
  ? {
    bankBranch: Yup.string().required(VALIDATION_KEYS.BRANCH_NAME_REQUIRED),
    }
  : {
      bankBranch: Yup.string().optional(),
    };

const validateInternationalBeneEmailID = internationalBeneConfig[
  "isEmailRequired"
]
  ? {
    beneEmail: Yup.string()
    .email(VALIDATION_KEYS.BENE_EMAIL_ID_VALIDATE)
    .required(VALIDATION_KEYS.BENE_EMAIL_ID_REQUIRED),
    }
  : {
      beneEmail: Yup.string().optional(),
    };

const validateInternationalBeneMobileNo = internationalBeneConfig[
  "isMobileNoRequired"
]
  ? {
    beneMobileNo: Yup.string()
    .min(8, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
    .max(15, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
    .required(VALIDATION_KEYS.BENE_MOBILE_NO_REQUIRED),
    }
  : {
      beneMobileNo: Yup.string().optional(),
    };

const validateInternationalBeneAddress = internationalBeneConfig[
  "isAddressRequired"
]
  ? {
    beneAddress: Yup.string().required(VALIDATION_KEYS.ADDRESS_REQUIRED),
    }
  : {
      beneAddress: Yup.string().optional(),
    };

const validateInternationalBeneCountry = internationalBeneConfig[
  "isBeneCountryRequired"
]
  ? {
    beneCountry: Yup.string().required(VALIDATION_KEYS.BENEFICIARY_COUNTRY_REQUIRED),
    }
  : {
      beneCountry: Yup.string().optional(),
    };

const validateInternationalBeneBankAddress = internationalBeneConfig[
  "isBankAddressRequired"
]
  ? {
    bankAddress: Yup.string().required(VALIDATION_KEYS.BANK_ADDRESS_REQUIRED),
    }
  : {
      bankAddress: Yup.string().optional(),
    };

const validateInternationalBeneBankCountry = internationalBeneConfig[
  "isBankCountryRequired"
]
  ? {
    bankCountry: Yup.string().required(VALIDATION_KEYS.BANK_COUNTRY_REQUIRED),
    }
  : {
      bankCountry: Yup.string().optional(),
    };

const validateInternationalBeneCode = internationalBeneConfig["isCodeRequired"]
  ? {
    code: Yup.string().when('modeofTransfer', {
      is: 'IFSC',
      then: Yup.string()
        .required(VALIDATION_KEYS.IFSC_CODE_REQUIRED)
        .min(8, VALIDATION_KEYS.IFSC_CODE_MIN_MAX)
        .max(11, VALIDATION_KEYS.IFSC_CODE_MIN_MAX),
      otherwise: Yup.string().when('modeofTransfer', {
        is: 'Routing',
        then: Yup.string()
          .required(VALIDATION_KEYS.ROUTING_NUMBER_REQUIRED)
          .min(8, VALIDATION_KEYS.ROUTING_NUMBER_MIN_MAX)
          .max(11, VALIDATION_KEYS.ROUTING_NUMBER_MIN_MAX),
      otherwise: Yup.string()  
        .min(8, VALIDATION_KEYS.SWIFT_CODE_MIN_MAX)
        .max(11, VALIDATION_KEYS.SWIFT_CODE_MIN_MAX)
        .required(VALIDATION_KEYS.SWIFT_CODE_REQUIRED),
      })
    }),
    }
  : {
      code: Yup.string().optional(),
    };
const validateInternalTransferAmount = internalTransferConfig[
  "isAmountRequired"
]
  ? {
    transferAmount: Yup.string()
    .required(VALIDATION_KEYS.TRANSFER_AMOUNT_REQUIRED),
    }
  : {
      transferAmount: Yup.string().optional(),
    };

const validateInternalTransferRemarks = internalTransferConfig[
  "isRemarksRequired"
]
  ? {
    remarks: Yup.string().required(VALIDATION_KEYS.REMARKS_REQUIRED),
    }
  : {
      remarks: Yup.string().optional(),
    };

const validateInternalTransferBeneAlert = internalTransferConfig[
  "isBeneAlertRequired"
]
  ? {
    beneAlert: Yup.string().required(VALIDATION_KEYS.BENE_ALERT_REQUIRED),
    }
  : {
      beneAlert: Yup.string().optional(),
    };

const validateInternalTransferTxnCurrency = internalTransferConfig[
  "isCurrencyRequired"
]
  ? {
    txnCurrency: Yup.string().required(VALIDATION_KEYS.CURRENCY_REQUIRED),
    }
  : {
      txnCurrency: Yup.string().optional(),
    };

const validateInternalTransferIsScheduled = internalTransferConfig[
  "isSchedulePaymentRequired"
]
  ? {
    isScheduled: Yup.string().required(VALIDATION_KEYS.SCHEDULED_PAYMENT_REQUIRED),
    }
  : {
      isScheduled: Yup.string().optional(),
    };

const validateInternalTransferScheduledDate = internalTransferConfig[
  "isScheduleDateRequired"
]
  ? {
    scheduledDate: Yup.string().when('isScheduled', {
      is: 'Yes',
      then: Yup.string().required(VALIDATION_KEYS.SCHEDULED_DATE_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
    }
  : {
      scheduledDate: Yup.string().optional(),
    };
const validateInternalTransferFxRefNo = internalTransferConfig[
  "isFxRefNoRequired"
]
  ? {
    fxRefNo: Yup.string().when('hasFxRefNo', {
      is: 'Y',
      then: Yup.string().required(VALIDATION_KEYS.FX_REF_NO_REQUIRED),
      otherwise: Yup.string(),
    }),
    }
  : {
      fxRefNo: Yup.string().optional(),
    };
const validateInternalTransferCustomRemark = internalTransferConfig[
  "isCustomRemarksRequired"
]
  ? {
    customRemarks: Yup.string().when('remarks', {
      is: 'Custom',
      then: Yup.string().required(VALIDATION_KEYS.CUSTOM_REMARK_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
    }
  : {
      customRemarks: Yup.string().optional(),
    };

const validateDomesticTransferAmount = domesticTransferConfig[
  "isAmountRequired"
]
  ? {
    transferAmount: Yup.string()
    .required('Transfer Amount is required'),
    }
  : {
      transferAmount: Yup.string().optional(),
    };

const validateDomesticTransferRemarks = domesticTransferConfig[
  "isRemarksRequired"
]
  ? {
    remarks: Yup.string().required(VALIDATION_KEYS.REMARKS_REQUIRED),
    }
  : {
      remarks: Yup.string().optional(),
    };

const validateDomesticTransferBeneAlert = domesticTransferConfig[
  "isBeneAlertRequired"
]
  ? {
    beneAlert: Yup.string().required(VALIDATION_KEYS.BENE_ALERT_REQUIRED),
    }
  : {
      beneAlert: Yup.string().optional(),
    };

const validateDomesticTransferIsScheduled = domesticTransferConfig[
  "isSchedulePaymentRequired"
]
  ? {
    isScheduled: Yup.string().required(VALIDATION_KEYS.SCHEDULED_PAYMENT_REQUIRED),
    }
  : {
      isScheduled: Yup.string().optional(),
    };

const validateDomesticTransferScheduledDate = domesticTransferConfig[
  "isScheduleDateRequired"
]
  ? {
    scheduledDate: Yup.string().when('isScheduled', {
      is: 'Yes',
      then: Yup.string().required(VALIDATION_KEYS.SCHEDULED_DATE_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
    }
  : {
      scheduledDate: Yup.string().optional(),
    };

const validateDomesticTransferCustomRemark = domesticTransferConfig[
  "isCustomRemarksRequired"
]
  ? {
    customRemarks: Yup.string().when('remarks', {
      is: 'Custom',
      then: Yup.string().required(VALIDATION_KEYS.CUSTOM_REMARK_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
    }
  : {
      customRemarks: Yup.string().optional(),
    };

const validateInternationalTransferAmount = internationalTransferConfig[
  "isAmountRequired"
]
  ? {
    transferAmount: Yup.string()
    .required(VALIDATION_KEYS.TRANSFER_AMOUNT_REQUIRED),
    }
  : {
      transferAmount: Yup.string().optional(),
    };

const validateInternationalTransferRemarks = internationalTransferConfig[
  "isRemarksRequired"
]
  ? {
    remarks: Yup.string().required(VALIDATION_KEYS.REMARKS_REQUIRED),
    }
  : {
      remarks: Yup.string().optional(),
    };

const validateInternationalTransferBeneAlert = internationalTransferConfig[
  "isBeneAlertRequired"
]
  ? {
    beneAlert: Yup.string().required(VALIDATION_KEYS.BENE_ALERT_REQUIRED),
    }
  : {
      beneAlert: Yup.string().optional(),
    };

const validateInternationalTransferSenderToReceiver = internationalTransferConfig[
  "isSenderInfoRequired"
]
  ? {
    senderToReceiverInfo: Yup.string().required(VALIDATION_KEYS.SENDER_TO_RECEIVER_INFO),
    }
  : {
      senderToReceiverInfo: Yup.string().optional(),
    };

const validateInternationalTransferIsScheduled = internationalTransferConfig[
  "isSchedulePaymentRequired"
]
  ? {
    isScheduled: Yup.string().required(VALIDATION_KEYS.SCHEDULED_PAYMENT_REQUIRED),
    }
  : {
      isScheduled: Yup.string().optional(),
    };

const validateInternationalTransferScheduledDate = internationalTransferConfig[
  "isScheduleDateRequired"
]
  ? {
    scheduledDate: Yup.string().when('isScheduled', {
      is: 'Yes',
      then: Yup.string().required(VALIDATION_KEYS.SCHEDULED_DATE_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
    }
  : {
      scheduledDate: Yup.string().optional(),
    };
const validateInternationalTransferFxRefNo = internationalTransferConfig[
  "isFxRefRequired"
]
  ? {
    fxRefNo: Yup.string().when('hasFxRefNo', {
      is: 'Y',
      then: Yup.string().required(VALIDATION_KEYS.FX_REF_NO_REQUIRED),
      otherwise: Yup.string(),
    }),
    }
  : {
      fxRefNo: Yup.string().optional(),
    };
const validateInternationalTransferCustomRemark = internationalTransferConfig[
  "isCustomRemarksRequired"
]
  ? {
    customRemarks: Yup.string().when('remarks', {
      is: 'Custom',
      then: Yup.string().required(VALIDATION_KEYS.CUSTOM_REMARK_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
    }
  : {
      customRemarks: Yup.string().optional(),
    };
const validateOwnTransferAmount = ownTransferConfig["isAmountRequired"]
  ? {
    transferAmount: Yup.string()
    .required(VALIDATION_KEYS.TRANSFER_AMOUNT_REQUIRED),
    }
  : {
      transferAmount: Yup.string().optional(),
    };

const validateOwnTransferRemarks = ownTransferConfig["isRemarksRequired"]
  ? {
  remarks: Yup.string().required(VALIDATION_KEYS.REMARKS_REQUIRED),
    }
  : {
      remarks: Yup.string().optional(),
    };

const validateOwnTransferBeneAlert = ownTransferConfig["isBeneAlertRequired"]
  ? {
    beneAlert: Yup.string().required(VALIDATION_KEYS.BENE_ALERT_REQUIRED),
    }
  : {
      beneAlert: Yup.string().optional(),
    };

const validateOwnTransferTxnCurrency = ownTransferConfig["isCurrencyRequired"]
  ? {
    txnCurrency: Yup.string().required(VALIDATION_KEYS.CURRENCY_REQUIRED),
    }
  : {
      txnCurrency: Yup.string().optional(),
    };

const validateOwnTransferFxRefNo = ownTransferConfig["isFxRefNoRequired"]
  ? {
    fxRefNo: Yup.string().when('hasFxRefNo', {
      is: 'Y',
      then: Yup.string().required(VALIDATION_KEYS.FX_REF_NO_REQUIRED),
      otherwise: Yup.string(),
    }),
    }
  : {
      fxRefNo: Yup.string().optional(),
    };
const validateOwnTransferCustomRemark = ownTransferConfig[
  "isCustomRemarksRequired"
]
  ? {
    customRemarks: Yup.string().when('remarks', {
      is: 'Custom',
      then: Yup.string().required(VALIDATION_KEYS.CUSTOM_REMARK_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
    }
  : {
      customRemarks: Yup.string().optional(),
    };

const validateBulkTransferAccountNo = bulkTransferConfig["isAccountNoRequired"]
  ? {
    accountNo: Yup.string().required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
    }
  : {
      accountNo: Yup.string().optional(),
    };

const validateBulkTransferAmount = bulkTransferConfig["isAmountRequired"]
  ? {
    maxTransferAmount: Yup.string().required(VALIDATION_KEYS.TRANSFER_AMOUNT_REQUIRED),
    }
  : {
      maxTransferAmount: Yup.string().optional(),
    };

const validateBulkTransferType = bulkTransferConfig["isTransferTypeRequired"]
  ? {
    transferType: Yup.string().required(VALIDATION_KEYS.TRANSFER_TYPE_REQUIRED),
    }
  : {
      transferType: Yup.string().optional(),
    };

const validateBulkTxnCurrency = bulkTransferConfig["isTxnCurrencyRequired"]
  ? {
    txnCurrency: Yup.string().required(VALIDATION_KEYS.TXN_CURRENCY_REQUIRED),
  }
  : {
    txnCurrency: Yup.string().optional(),
  };

const validateBulkTransferRemarks = bulkTransferConfig["isRemarksRequired"]
  ? {
    remarks: Yup.string().required(VALIDATION_KEYS.REMARKS_REQUIRED),
    }
  : {
      remarks: Yup.string().optional(),
    };

const validateBulkTransferBeneName = bulkTransferConfig["isBeneNameRequired"]
  ? {
    beneAccNo: Yup.string().required(VALIDATION_KEYS.BENEFICIARY_NAME_REQUIRED),
    }
  : {
      beneAccNo: Yup.string().optional(),
    };

const validateRegionalBeneNickName = regionalBeneConfig["isNickNameRequired"]
  ? {
    nickName: Yup.string()
      .required(VALIDATION_KEYS.NICK_NAME_REQUIRED)
      .matches(new RegExp('^[a-zA-Z_]*$'), VALIDATION_KEYS.VALID_NICK_NAME)
      .min(2, VALIDATION_KEYS.NICK_NAME_MIN_MAX)
      .max(20, VALIDATION_KEYS.NICK_NAME_MIN_MAX),
  }
  : {
    nickName: Yup.string().optional(),
  };
const validateRegionalBeneAccountNo = regionalBeneConfig["isAccountNoRequired"]
  ? {
    accountNumber: Yup.string()
      .min(5, VALIDATION_KEYS.ACCOUNT_NO_MIN_MAX)
      .max(20, VALIDATION_KEYS.ACCOUNT_NO_MIN_MAX)
      .required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
  }
  : {
    accountNumber: Yup.string().optional(),
  };
const validateRegionalBeneConfirmAccountNo = regionalBeneConfig[
  "isConfirmAccountNoRequired"
]
  ? {
    confirmAccountNumber: Yup.string()
      .oneOf([Yup.ref('accountNumber'), null], VALIDATION_KEYS.ACCOUNT_NO_MATCH)
      .required(VALIDATION_KEYS.CONFIRM_ACCOUNT_NO_REQUIRED),
  }
  : {
    confirmAccountNumber: Yup.string().optional(),
  };
const validateRegionalBeneTransaferAmount = regionalBeneConfig[
  "isTransferLimitRequired"
]
  ? {
    maxTransferAmount: Yup.string().required(VALIDATION_KEYS.TRANSFER_LIMIT),
  }
  : {
    maxTransferAmount: Yup.string().optional(),
  };

const validateRegionalBeneName = regionalBeneConfig["isBeneNameRequired"]
  ? {
    benName: Yup.string()
      .required(VALIDATION_KEYS.BENEFICIARY_NAME_REQUIRED)
      .matches(new RegExp('^[a-zA-Z ]*$'), VALIDATION_KEYS.BENEFICIARY_NAME_VALID)
      .min(2, VALIDATION_KEYS.BENEFICIARY_MIN_MAX)
      .max(32, VALIDATION_KEYS.BENEFICIARY_MIN_MAX),
  }
  : {
    benName: Yup.string().optional(),
  };

const validateRegionalBeneBankName = regionalBeneConfig["isBeneBankRequired"]
  ? {
    bankName: Yup.string().required(VALIDATION_KEYS.BENEFICIARY_BANK_REQUIRED),
  }
  : {
    bankName: Yup.string().optional(),
  };

const validateRegionalBeneBranchName = regionalBeneConfig["isBranchRequired"]
  ? {
    branchName: Yup.string().required(VALIDATION_KEYS.BRANCH_NAME_REQUIRED),
  }
  : {
    branchName: Yup.string().optional(),
  };

const validateRegionalBeneEmailID = regionalBeneConfig["isEmailRequired"]
  ? {
    beneEmail: Yup.string()
      .email(VALIDATION_KEYS.BENE_EMAIL_ID_VALIDATE)
      .required(VALIDATION_KEYS.BENE_EMAIL_ID_REQUIRED),
  }
  : {
    beneEmail: Yup.string().optional(),
  };

const validateRegionalBeneMobileNo = regionalBeneConfig["isMobileNoRequired"]
  ? {
    beneMobileNo: Yup.string()
      .min(8, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
      .max(15, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
      .required(VALIDATION_KEYS.BENE_MOBILE_NO_REQUIRED),
  }
  : {
    beneMobileNo: Yup.string().optional(),
  };

const validateRegionalTransferAmount = regionalTransferConfig[
  "isAmountRequired"
]
  ? {
    transferAmount: Yup.string()
      .required('Transfer Amount is required'),
  }
  : {
    transferAmount: Yup.string().optional(),
  };

const validateRegionalTransferRemarks = regionalTransferConfig[
  "isRemarksRequired"
]
  ? {
    remarks: Yup.string().required(VALIDATION_KEYS.REMARKS_REQUIRED),
  }
  : {
    remarks: Yup.string().optional(),
  };



const validateRegionalTransferIsScheduled = regionalTransferConfig[
  "isSchedulePaymentRequired"
]
  ? {
    isScheduled: Yup.string().required(VALIDATION_KEYS.SCHEDULED_PAYMENT_REQUIRED),
  }
  : {
    isScheduled: Yup.string().optional(),
  };

const validateRegionalTransferScheduledDate = regionalTransferConfig[
  "isScheduleDateRequired"
]
  ? {
    scheduledDate: Yup.string().when('isScheduled', {
      is: 'Yes',
      then: Yup.string().required(VALIDATION_KEYS.SCHEDULED_DATE_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
  }
  : {
    scheduledDate: Yup.string().optional(),
  };
      

export const AddBeneficiarySchema = Yup.object().shape({
  nickName: Yup.string()
    .required()
    .matches(new RegExp("^[a-zA-Z ]*$"), "Text only"),
  accountNumber: Yup.string().required(),
  confirmAccountNumber: Yup.string()
    .oneOf([Yup.ref("accountNumber"), null])
    .required("Account confirm is required"),
  bank: Yup.string().required(),
  branch: Yup.string().required(),
  transferLimit: Yup.string().required(),
});

export const TransferSchema = Yup.object().shape({
  amount: Yup.string().required(),
  description: Yup.string(),
});

export const AddInternalBeneficiarySchema = Yup.object().shape({
  ...validateNickName,
  ...validateInternalBeneAccountNo,
  ...validateInternalBeneConfirmAccountNo,
  ...validateInternalBeneTransaferAmount,
})

export const AddThirdPartyBeneficiarySchema = Yup.object().shape({
    ...validateDomesticBeneNickName,
    ...validateDomesticBeneAccountNo,
    ...validateDomesticBeneConfirmAccountNo,
    ...validateDomesticBeneTransaferAmount,
    ...validateDomesticBeneName,
    ...validateDomesticBeneBankName,
    // ...validateDomesticBeneBranchName,
    ...validateDomesticBeneEmailID,
    ...validateDomesticBeneMobileNo,
})

export const AddRegionalBeneficiarySchema = Yup.object().shape({
  ...validateRegionalBeneNickName,
  ...validateRegionalBeneAccountNo,
  ...validateRegionalBeneConfirmAccountNo,
  ...validateRegionalBeneTransaferAmount,
  ...validateRegionalBeneName,
  ...validateRegionalBeneBankName,
  ...validateRegionalBeneBranchName,
  ...validateRegionalBeneEmailID,
  ...validateRegionalBeneMobileNo,
})

export const AddInternationalBeneficiarySchema = Yup.object().shape({
  ...validateInternationalBeneName,
  ...validateInternationalBeneNickName,
  ...validateInternationalBeneAccountNo,
  ...validateInternationalBeneConfirmAccountNo,
  ...validateInternationalBeneTransaferAmount,
  ...validateInternationalBeneBankAddress,
  ...validateInternationalBeneCountry,
  ...validateInternationalBeneBankName,
  ...validateInternationalBeneBranchName,
  ...validateInternationalBeneEmailID,
  ...validateInternationalBeneMobileNo,
  ...validateInternationalBeneBankCountry,
  ...validateInternationalBeneAddress,
  ...validateInternationalBeneCode,
  
})

export const FundTransfer = Yup.object().shape({
  transferAmount: Yup.string().required(VALIDATION_KEYS.AMOUNT_REQUIRED),
  remarks: Yup.string().min(4, 'Minimum 4 Characters').required(VALIDATION_KEYS.REMARKS_REQUIRED),
  transferType: Yup.string().required('TransferType is required'),
  //  showCurrency:Yup.boolean(),
  //  currency: Yup.string().when('showCurrency', {
  //   is: true,
  //   then: Yup.string().required('Please Select Currency'),
  //   otherwise: Yup.string(),
  // })
});

const validateTotalAmount = salaryUploadConfig[
  "isAccountNoRequired"
]
  ? {
    amount: Yup.string()
      .required(VALIDATION_KEYS.TOTAL_AMOUNT_REQUIRED),
  }
  : {
    amount: Yup.string().optional(),
  };

const validateProcessName = salaryUploadConfig[
  "isAccountNoRequired"
]
  ? {
    fileProcessName: Yup.string()
      .required(VALIDATION_KEYS.PROCESS_NAME_REQUIRED),
  }
  : {
    fileProcessName: Yup.string().optional(),
  };



    
export const validateFileUpload = Yup.object().shape({
  ...validateProcessName,
  ...validateTotalAmount,
  remarks: Yup.string().required(VALIDATION_KEYS.NARRATIVE),
}); 

export const InternalTransferSchema = Yup.object().shape({
  ...validateInternalTransferAmount,
  ...validateInternalTransferRemarks,
  // ...validateInternalTransferBeneAlert,
  // ...validateInternalTransferTxnCurrency,
  // ...validateInternalTransferFxRefNo,
  ...validateInternalTransferIsScheduled,
  ...validateInternalTransferScheduledDate,
  // ...validateInternalTransferCustomRemark,
   
})

export const OwnTransferSchema = Yup.object().shape({
  ...validateOwnTransferAmount,
  ...validateOwnTransferRemarks,
  // ...validateOwnTransferBeneAlert,
  ...validateOwnTransferTxnCurrency,
  // ...validateOwnTransferFxRefNo,
  ...validateOwnTransferCustomRemark,
 
})

export const OtherTransferSchema = Yup.object().shape({
  ...validateDomesticTransferAmount,
  ...validateDomesticTransferRemarks,
  // ...validateDomesticTransferBeneAlert,
  // ...validateDomesticTransferCustomRemark,
  ...validateDomesticTransferIsScheduled,
  ...validateDomesticTransferScheduledDate,
 
})

export const RegionalTransferSchema = Yup.object().shape({
  ...validateRegionalTransferAmount,
  ...validateRegionalTransferRemarks,
  ...validateRegionalTransferIsScheduled,
  ...validateRegionalTransferScheduledDate,
 
})

export const InternationalTransferSchema = Yup.object().shape({
  ...validateInternationalTransferAmount,
  ...validateInternationalTransferFxRefNo,
  // ...validateInternationalTransferSenderToReceiver,
  ...validateInternationalTransferRemarks,
  // ...validateInternationalTransferBeneAlert,
  // ...validateInternationalTransferCustomRemark,
  ...validateInternationalTransferIsScheduled,
  ...validateInternationalTransferScheduledDate,
  ...validateInternalTransferTxnCurrency
})

const validateEditInternalNickName = editInternalConfig["isNickNameRequired"]
  ? {
    nickName: Yup.string()
    .required(VALIDATION_KEYS.NICK_NAME_REQUIRED)
    .min(2, VALIDATION_KEYS.NICK_NAME_MIN_MAX)
    .max(20, VALIDATION_KEYS.NICK_NAME_MIN_MAX),
  }
  : {
      nickName: Yup.string().optional(),
    };

const validateEditInternalAmount = editInternalConfig["isTransferLimitRequired"]
  ? {
    maxTransferAmount: Yup.string().required(VALIDATION_KEYS.TRANSFER_LIMIT),
    }
  : {
      maxTransferAmount: Yup.string().optional(),
    };

export const EditInternalBeneficiarySchema = Yup.object().shape({
  accountNumber: Yup.string().required(VALIDATION_KEYS.REQUIRED),
  ...validateEditInternalNickName,
  ...validateEditInternalAmount,
})

export const EditOtherBeneficiarySchema = Yup.object().shape({
  nickName: Yup.string()
    .required(VALIDATION_KEYS.NICK_NAME_REQUIRED)
    .min(2, VALIDATION_KEYS.NICK_NAME_MIN_MAX)
    .max(20, VALIDATION_KEYS.NICK_NAME_MIN_MAX),
  accountNumber: Yup.string().required(VALIDATION_KEYS.REQUIRED),
  beneEmail: Yup.string()
    .email(VALIDATION_KEYS.BENE_EMAIL_ID_VALIDATE)
    .required(VALIDATION_KEYS.BENE_EMAIL_ID_REQUIRED),
  beneMobileNo: Yup.string()
    .min(8, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
    .max(15, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
    .required(VALIDATION_KEYS.BENE_MOBILE_NO_REQUIRED),
  maxTransferAmount: Yup.string().required(VALIDATION_KEYS.TRANSFER_LIMIT),
})

export const EditRegionalBeneficiarySchema = Yup.object().shape({
  nickName: Yup.string()
    .required(VALIDATION_KEYS.NICK_NAME_REQUIRED)
    .min(2, VALIDATION_KEYS.NICK_NAME_MIN_MAX)
    .max(20, VALIDATION_KEYS.NICK_NAME_MIN_MAX),
  accountNumber: Yup.string().required(VALIDATION_KEYS.REQUIRED),
  beneEmail: Yup.string()
    .email(VALIDATION_KEYS.BENE_EMAIL_ID_VALIDATE)
    .required(VALIDATION_KEYS.BENE_EMAIL_ID_REQUIRED),
  beneMobileNo: Yup.string()
    .min(8, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
    .max(15, VALIDATION_KEYS.BENE_MOBILE_NO_MIN_MAX)
    .required(VALIDATION_KEYS.BENE_MOBILE_NO_REQUIRED),
  maxTransferAmount: Yup.string().required(VALIDATION_KEYS.TRANSFER_LIMIT),
})

export const RepeatTransferSchema = Yup.object().shape({
  transferAmount: Yup.string().required(VALIDATION_KEYS.TRANSFER_AMOUNT_REQUIRED),
  remarks: Yup.string().required(VALIDATION_KEYS.REMARKS_REQUIRED),
  customRemarks: Yup.string().when('remarks', {
    is: 'Custom',
    then: Yup.string().required(VALIDATION_KEYS.CUSTOM_REMARK_REQUIRED),
    otherwise: Yup.string().optional(),
  }),
});

// eslint-disable-next-line import/prefer-default-export
export const QuickPaySchema = Yup.object().shape({
  ...validateAccountType,
  ...validateBankName,
  ...validateBranchName,
  ...validateAccountNo,
  ...validateConfirmAccountNo,
  ...validateBeneName,
  ...validateRemarks,
  ...validateCustomRemarks,
  ...validateTransactionCurrency,

  sourceAccount: Yup.string(),
  sourceBranch: Yup.string(),
  sourceCurrency: Yup.string(),
  bankCode: Yup.number(),
  amount: Yup.string()
    // .matches(new RegExp('^[red1-9][0-9]*$'), 'Instant transfer should not start with 0')
    .required(VALIDATION_KEYS.AMOUNT_REQUIRED),
  
  bank: Yup.string(),
  branch: Yup.string(),

})

export const BulkTransferSchema = Yup.object().shape({
  ...validateBulkTransferAccountNo,
  ...validateBulkTransferBeneName,
  ...validateBulkTransferRemarks,
  ...validateBulkTransferAmount,
  ...validateBulkTransferType,
  ...validateBulkTxnCurrency,
  
})
